import React from "react";
import { Box, Alert } from "@mui/material";
import { XCircleIcon } from "@heroicons/react/24/outline";

interface AlertProps {
  onClick: any;
  message: string;
}

export const AlertElement: React.FC<AlertProps> = ({ onClick, message }) => (
  <Alert
    variant="filled"
    severity="error"
    onClick={onClick}
    icon={false}
    action={
      <Box sx={{ cursor: "pointer", pt: "2px" }}>
        <XCircleIcon width={26} height={26} />
      </Box>
    }
    sx={{ whiteSpace: "break-spaces" }}
  >
    {message}
  </Alert>
);
